import React, { useState } from 'react';
import { FetchNextPageFunction } from '../StudyList';
import { Button, createToast, Toast } from 'components/core';
import { Inline } from 'components/layout';

export type StudyListProps = {
  fetchNextPage: FetchNextPageFunction;
  hasNextPage: boolean;
};

export const LoadMoreButton = ({
  fetchNextPage,
  hasNextPage,
}: StudyListProps) => {
  const [isLoading, setIsLoading] = useState(false);

  if (!hasNextPage) {
    return null;
  }

  const handleFetchNextPage = async (): Promise<void> => {
    if (isLoading) {
      return;
    }

    try {
      setIsLoading(true);
      await fetchNextPage();
    } catch {
      createToast(
        <Toast type="danger" role="alert">
          Oh no! We&apos;re experiencing some technical difficulties right now,
          please try again later
        </Toast>
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Inline>
      <Button
        type="brand"
        size="sm"
        variant="solid"
        onClick={handleFetchNextPage}
        isLoading={isLoading}
      >
        Load more
      </Button>
    </Inline>
  );
};
